import React, { useState, useEffect } from "react";
import styles from "styles/genai/Edetail.module.scss";
import cardsstatus from "img/genai/cardstatus.svg";
import downloadicon from "img/genai/download.svg";
import suggestion from "img/genai/suggestions.svg";
import viewport from "img/genai/viewport.svg";
import tick from "img/genai/tick.svg";
import cross from "img/genai/cross.svg";
import styled from "styled-components";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { PaginationEdt } from "./PaginationEdt";
import { PreviewModal } from "./PreviewModal";
import { ToastContainer, toast } from "react-toastify";
import ConfirmationModal from "../utils/ConfirmationModal";

export const SlideCard = ({
  slideData,
  checkSlideSelect,
  edtName,
  messages,
  messageId,
  selectedeDetail,
  message,
  greySlideIds,
  setSlideBubbleState,
  moduleCreation,
  slidePopup,
  setGryRetrivedSlideIds
}) => {
  const { showSlideMsg, setShowSlideMsg } = slidePopup;
  const [selectedSlides, setSelectedSlides] = useState({
    assetId: null,
    slideIds: [],
    slidenums: [],
    signedUrls: [],
  });
  const [showModal, setShowModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  // Add confirmation modal states
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationModalProps, setConfirmationModalProps] = useState({
    message: "",
    onProceed: () => {},
    onCancel: () => {},
  });

  const [currentPage, setCurrentPage] = useState(1);
  const slidesPerPage = 8;
  const MAX_SELECTION_LIMIT = 5;

  const totalSlides = slideData.pageDetails.length;
  const totalPages = Math.ceil(totalSlides / slidesPerPage);
  const indexOfLastSlide = currentPage * slidesPerPage;
  const indexOfFirstSlide = indexOfLastSlide - slidesPerPage;
  const currentSlides = slideData.pageDetails.slice(
    indexOfFirstSlide,
    indexOfLastSlide
  );
  const { showModuleCreation, setShowModuleCreation } = moduleCreation;
  const preventContextMenu = (e) => e.preventDefault();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Helper function to show confirmation modal
  const showConfirmation = (message, onProceed, onCancel) => {
    setConfirmationModalProps({
      message,
      onProceed: () => {
        onProceed();
        setGryRetrivedSlideIds(true);
        setShowConfirmationModal(false);
      },
      onCancel: () => {
        onCancel();
        setShowConfirmationModal(false);
      },
    });
    setShowConfirmationModal(true);
  };

  const handleCardClick = (pageId) => {
    // If showSlideMsg is true, show confirmation modal
    if (showSlideMsg) {
      const pageData = slideData.pageDetails.find((p) => p.pageId === pageId);
      if (!pageData) return;

      const slideNumber = `Slide_${pageData.pageNo}`;
      const isAlreadySelected = selectedSlides.slideIds.includes(pageId);

      showConfirmation(
        "Adding/removing slides will abort the previous actions. Are you sure?",
        () => {
          // Execute the slide selection/deselection
          if (showModuleCreation) {
            setShowModuleCreation(false);
          }

          setSelectedSlides((prev) => {
            let newSlideIds, newSlideNums;

            if (isAlreadySelected) {
              newSlideIds = prev.slideIds.filter((id) => id !== pageId);
              newSlideNums = prev.slidenums.filter(
                (num) => num !== slideNumber
              );
            } else {
              if (prev.slideIds.length >= MAX_SELECTION_LIMIT) {
                const toastId = "limit-warning";
                if (!toast.isActive(toastId)) {
                  toast.warning(
                    "Maximum of 5 slides can be selected at once.",
                    {
                      toastId,
                    }
                  );
                }
                return prev;
              }
              newSlideIds = [...prev.slideIds, pageId];
              newSlideNums = [...(prev.slidenums || []), slideNumber];
            }

            const newSignedUrls = slideData.pageDetails
              .filter((page) => newSlideIds.includes(page.pageId))
              .map((page) => ({
                pageId: page.pageId,
                signedUrl: page.signedUrl,
              }));

            const newSelection = {
              assetId: slideData.assetId,
              slideIds: newSlideIds,
              slidenums: newSlideNums,
              signedUrls: newSignedUrls,
            };

            checkSlideSelect(newSelection);

            // Turn off the flag after confirmation
            setShowSlideMsg(false);
            return newSelection;
          });
        },
        () => {
          // User cancelled - do nothing
        }
      );
      return;
    }

    // Original logic only executes if showSlideMsg is false
    if (showModuleCreation) {
      setShowModuleCreation(false);
    }

    const pageData = slideData.pageDetails.find((p) => p.pageId === pageId);
    if (!pageData) return;

    const slideNumber = `Slide_${pageData.pageNo}`;

    setSelectedSlides((prev) => {
      const isAlreadySelected = prev.slideIds.includes(pageId);
      let newSlideIds, newSlideNums;

      if (isAlreadySelected) {
        newSlideIds = prev.slideIds.filter((id) => id !== pageId);
        newSlideNums = prev.slidenums.filter((num) => num !== slideNumber);
      } else {
        if (prev.slideIds.length >= MAX_SELECTION_LIMIT) {
          const toastId = "limit-warning";

          if (!toast.isActive(toastId)) {
            toast.warning("Maximum of 5 slides can be selected at once.", {
              toastId,
            });
          }
          return prev;
        }

        newSlideIds = [...prev.slideIds, pageId];
        newSlideNums = [...(prev.slidenums || []), slideNumber];
      }

      const newSignedUrls = slideData.pageDetails
        .filter((page) => newSlideIds.includes(page.pageId))
        .map((page) => ({
          pageId: page.pageId,
          signedUrl: page.signedUrl,
        }));

      const newSelection = {
        assetId: slideData.assetId,
        slideIds: newSlideIds,
        slidenums: newSlideNums,
        signedUrls: newSignedUrls,
      };

      checkSlideSelect(newSelection);
      return newSelection;
    });
  };

  const processPreviewData = (data) => {
    if (!data) return null;

    if (data.image && data.pageNo) {
      return {
        pageDetails: [
          {
            signedUrl: data.image,
            pageNo: data.pageNo,
          },
        ],
      };
    }

    if (Array.isArray(data.pageDetails)) {
      return data;
    }

    return null;
  };

  const handleImageClick = (slideOrEdetail) => {
    const normalized = processPreviewData(slideOrEdetail);
    if (!normalized) return;

    setPreviewData(normalized);
    setShowModal(true);
  };

  const transformedSlideData = [
    {
      maintitle: `Here are all the slides from the selected ${
        edtName ? `asset (${edtName})` : null
      }
. Select up to 5 slides to proceed with module creation. You can also preview the slides`,
    },
    ...currentSlides.map((page) => ({
      id: page.pageId,
      image: page.signedUrl,
      slidenum: `Slide_${page.pageNo}`,
      isdisabled: false,
      pageNo: page.pageNo,
      claims: page.claims,
      RTs: page.RTs,
    })),
  ];

  const isLatestMessage =
    messages.filter((msg) => msg.responseType === "slide").slice(-1)[0]?.id ===
    messageId;

  const isGreyedOut = greySlideIds.includes(messageId);
  const shouldGreyOut = !isLatestMessage || isGreyedOut;

  const greyOutStyle = {
    opacity: shouldGreyOut ? 0.5 : 1,
    pointerEvents: shouldGreyOut ? "none" : "auto",
    filter: shouldGreyOut ? "grayscale(80%)" : "none",
    transition: "all 0.3s ease",
  };

  const slideselect = selectedSlides.slideIds.map((cardId, i) => {
    const slide = slideData.pageDetails.find((page) => page.pageId === cardId);
    const slideName = slide ? `Slide_${slide.pageNo}` : cardId;

    return (
      <div className={styles.selectedSlideslist} style={greyOutStyle} key={i}>
        <span>{slideName}</span>
        <span
          onClick={(e) => {
            if (!isLatestMessage) return;
            e.stopPropagation();

            // If showSlideMsg is true, show confirmation for removal too
            if (showSlideMsg) {
              showConfirmation(
                "Adding/removing slides will abort the previous actions. Are you sure?",
                () => {
                  // Execute the removal
                  setSelectedSlides((prev) => {
                    const newSlideIds = prev.slideIds.filter(
                      (id) => id !== cardId
                    );
                    const newSlideNums = prev.slidenums.filter(
                      (num) => num !== slideName
                    );
                    const newSignedUrls = prev.signedUrls.filter(
                      (url) => url.pageId !== cardId
                    );

                    const newSelection = {
                      assetId: slideData.assetId,
                      slideIds: newSlideIds,
                      slidenums: newSlideNums,
                      signedUrls: newSignedUrls,
                    };

                    checkSlideSelect(newSelection);

                    // Turn off the flag after confirmation
                    setShowSlideMsg(false);
                    return newSelection;
                  });
                },
                () => {
                  // User cancelled - do nothing
                }
              );
              return;
            }

            // Original removal logic if showSlideMsg is false
            setSelectedSlides((prev) => {
              const newSlideIds = prev.slideIds.filter((id) => id !== cardId);
              const newSlideNums = prev.slidenums.filter(
                (num) => num !== slideName
              );
              const newSignedUrls = prev.signedUrls.filter(
                (url) => url.pageId !== cardId
              );

              const newSelection = {
                assetId: slideData.assetId,
                slideIds: newSlideIds,
                slidenums: newSlideNums,
                signedUrls: newSignedUrls,
              };

              checkSlideSelect(newSelection);
              return newSelection;
            });
          }}
          style={{ cursor: isLatestMessage ? "pointer" : "default" }}
        >
          <img className={styles.crossslide} src={cross} alt="Remove" />
        </span>
      </div>
    );
  });

  useEffect(() => {
    setSelectedSlides({
      assetId: null,
      slideIds: [],
      slidenums: [],
      signedUrls: [],
    });
  }, [selectedeDetail]);

  const isVisible = selectedSlides.slideIds.length > 0;

  useEffect(() => {
    if (showModuleCreation) {
      setShowModuleCreation(false);
    }
    const count = selectedSlides.slideIds.length;
    setSlideBubbleState({
      isShow: count === MAX_SELECTION_LIMIT,
      selectedCount: count,
      selectedBeforeRec: selectedSlides,
    });
   
  }, [selectedSlides]);

  return (
    <>
      <article className={styles.edetailmain} style={greyOutStyle}>
        <span className={styles.edtDetailsmsg}>
          <strong>{transformedSlideData[0].maintitle}</strong>
        </span>

        <PaginationEdt
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          style={greyOutStyle}
        />

        <article
          className={styles.slidesShowSelect}
          style={{ display: isVisible ? "flex" : "none" }}
        >
          {slideselect}
        </article>

        <div className={styles.eslidecontainer}>
          {transformedSlideData.slice(1).map((ele) => {
            const isSelected = selectedSlides.slideIds.includes(ele.id);
            const isDisabled = !(
              ele?.claims?.length > 0 || ele?.RTs?.length > 0
            );
            return (
              <article
                key={ele.id}
                className={`${styles.eslidesub} ${
                  isSelected ? styles.selectedCard : ""
                } ${isDisabled ? styles.disabledCard : ""}`}
                onClick={() =>
                  !isDisabled && isLatestMessage && handleCardClick(ele.id)
                }
                style={greyOutStyle}
              >
                {isSelected && (
                  <div className={styles.selectedTick}>
                    <img src={tick} alt="Selected" />
                  </div>
                )}

                {isDisabled && (
                  <StyledTooltip
                    title={
                      <span>
                        This slide does not contain a Claim or Reusable Text to
                        proceed with module creation
                      </span>
                    }
                    arrow
                    placement="bottom-start"
                  >
                    <InfoIconWrapper className={styles.tooltipIcon}>
                      <img src={suggestion} alt="slide-info" />
                    </InfoIconWrapper>
                  </StyledTooltip>
                )}

                <div
                  className={styles.imageContainer}
                  onClick={(e) => {
                    e.stopPropagation();
                    !isDisabled && isLatestMessage && handleImageClick(ele);
                  }}
                >
                  <img
                    className={styles.cardsimg}
                    src={ele.image}
                    onContextMenu={preventContextMenu}
                    alt={`Slide ${ele.pageNo}`}
                    style={{
                      objectFit: ele.image ? "fill" : "cover",
                    }}
                  />

                  {!isDisabled && (
                    <div
                      className={styles.previewOverlay}
                      onContextMenu={preventContextMenu}
                    >
                      <article className={styles.previewBox}>
                        <img
                          src={viewport}
                          onContextMenu={preventContextMenu}
                          alt="view"
                        />
                        <span>Preview</span>
                      </article>
                    </div>
                  )}
                </div>

                <article
                  className={`${styles.eslidebottom} ${
                    isDisabled ? styles.disabledBottom : ""
                  }`}
                >
                  <div className={styles.leftecard}>
                    <span className={styles.cardstatus}>
                      <strong>{ele.slidenum}</strong>
                    </span>
                  </div>
                  <div className={styles.rightecard}></div>
                </article>
              </article>
            );
          })}
        </div>
      </article>

      <PreviewModal
        show={showModal}
        onClose={() => setShowModal(false)}
        previewData={previewData}
      />

      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <ConfirmationModal
          message={confirmationModalProps.message}
          onProceed={confirmationModalProps.onProceed}
          onCancel={confirmationModalProps.onCancel}
        />
      )}
    </>
  );
};

const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#fff",
    color: "#333",
    fontSize: "12px",
    padding: "8px",
    borderRadius: "4px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.5",
    marginTop: "7px",
    marginRight: "18px",
    maxWidth: "210px",
    boxShadow: "0px 0px 8px 0px #231F201F",
  },
  arrow: {
    color: "#fff",
    width: "35px",
    height: "12px",
    paddingLeft: "9px",
    borderWidth: "2px",
    borderColor: "#fff",
    transform: "scale(1)",
  },
})(Tooltip);

const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 8px;
`;
